"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fklimat = void 0;
var jquery_1 = __importDefault(require("jquery"));
var underscore_1 = __importDefault(require("underscore"));
exports.Fklimat = {
    AdaptiveCharts: {
        theme: 'fklimat-both',
        charts: {},
        initialize: function () {
            this.calculateTheme();
        },
        register: function (id, callback) {
            this.charts[id] = callback;
        },
        calculateTheme: function () {
            return this.theme = this.isOnPhoneVersion() ?
                // Does a mobile theme even exist still? Is it the default HighCharts theme?
                // 'mobile'
                'fklimat-both'
                :
                    'fklimat-both';
        },
        calculateHeight: function (height, factor) {
            var targetHeight = height * (factor || 1);
            if (this.isOnPhoneVersion()) {
                return Math.min(450, height);
            }
            else {
                return targetHeight;
            }
        },
        isOnPhoneVersion: function () {
            var middle = jquery_1.default(window).width();
            return middle ? 320 <= middle && middle < 768 : false;
        },
        onResize: function () {
            var _this = this;
            var oldTheme = this.theme;
            this.calculateTheme();
            var newTheme = this.theme;
            if (oldTheme === newTheme) {
                return;
            }
            return (function () {
                var result = [];
                for (var id in exports.Fklimat.AdaptiveCharts.charts) {
                    // @ts-ignore
                    var callback = exports.Fklimat.AdaptiveCharts.charts[id];
                    result.push(callback(_this.theme));
                }
                return result;
            })();
        }
    },
    renderTo: function (elementId, presentable, parameters, callback, options, adaptive) {
        var drawChart = function (theme) {
            options = underscore_1.default.extend({}, options, { theme: theme });
            if (adaptive === null || adaptive === void 0 ? void 0 : adaptive.height) {
                var height = exports.Fklimat.AdaptiveCharts.calculateHeight(adaptive.height, adaptive.factor);
                adaptive.container.height(height);
            }
            var handle = Artilect.renderTo(elementId, presentable, parameters, callback, options);
            return handle.join(function (r, err) {
                if (window.renderFinished) {
                    return window.renderFinished(r, err);
                }
            });
        };
        exports.Fklimat.AdaptiveCharts.register(elementId, drawChart);
        return drawChart(exports.Fklimat.AdaptiveCharts.theme);
    }
};
// Execute the function when the DOM is ready to be used.
jquery_1.default(function () {
    exports.Fklimat.AdaptiveCharts.initialize();
    return jquery_1.default(window).resize(underscore_1.default.debounce(function () { return exports.Fklimat.AdaptiveCharts.onResize(); }, 250));
});
